export default __webpack_public_path__ + "static/media/06.137c14b5.png";